import { render } from "./Empresa.vue?vue&type=template&id=1498a9e6&scoped=true"
import script from "./Empresa.vue?vue&type=script&lang=js"
export * from "./Empresa.vue?vue&type=script&lang=js"

import "./Empresa.vue?vue&type=style&index=0&id=1498a9e6&scoped=true&lang=css"

import exportComponent from "J:\\Centrion\\projetos\\apracam_ios\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1498a9e6"]])

export default __exports__